import PropTypes from 'prop-types'
import { FormFeedback, Input, Label } from "reactstrap"
import React from "react";
import labelConstant from 'constants/label';
const Name = ({ validation }) => {

    return (
        <div className="    mb-3">
            <Label className="form-label">{labelConstant.NAME}<span className="text-danger">*</span></Label>
            <Input
                name="name"
                className="form-control"
                placeholder={"Enter " + labelConstant.NAME}
                type="text"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.name || ""}
                invalid={
                    validation.touched.name && validation.errors.name ? true : false
                }
            />
            {validation.touched.name && validation.errors.name ? (
                <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
            ) : null}
        </div>

    )
}

Name.propTypes = {
    validation: PropTypes.object,
}

export default Name
